<template>
	<div
		:class="{
			'el-tab-pane': true,
			'el-tab-pane__offset': visibility === 'offset' && !active,
			'el-tab-pane__zindex': visibility === 'zindex' && !active,
		}"
		v-if="!lazy || loaded || active"
		v-show="visibility !== 'display' ? true : visibility === 'display' && active"
		role="tabpanel"
		:aria-hidden="visibility !== 'display' ? false : visibility === 'display' && !active"
		:id="`pane-${paneName}`"
		:aria-labelledby="`tab-${paneName}`"
	>
		<slot></slot>
	</div>
</template>
<script>
export default {
	name: 'ElTabPane',
	componentName: 'ElTabPane',
	props: {
		label: String,
		labelContent: Function,
		name: String,
		closable: Boolean,
		disabled: Boolean,
		lazy: Boolean,
		visibility: {
			type: String,
			default: 'display',
		},
	},
	data() {
		return {
			index: null,
			loaded: false,
		};
	},
	computed: {
		isClosable() {
			return this.closable || this.$parent.closable;
		},
		active() {
			const active = this.$parent.currentName === (this.name || this.index);
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			if (active) this.loaded = true;

			return active;
		},
		paneName() {
			return this.name || this.index;
		},
	},
	updated() {
		this.$parent.$emit('tab-nav-update');
	},
};
</script>
<style lang="scss">
.el-tab-pane {
	z-index: 10;
}
.el-tab-pane__offset {
	height: 100%;
	position: absolute !important;
	top: -10000px !important;
}
.el-tab-pane__zindex {
	height: 100%;
	z-index: 0;
	position: absolute !important;
}
</style>
